
const setStorefrontAPIHeaders = (key) => (xhr) => {
    xhr.setRequestHeader('Content-Type', 'application/graphql');
    xhr.setRequestHeader('X-Shopify-Storefront-Access-Token', key);
}

var currencyDisplay = {
    USD: '$',
    AUD: 'AU$',
    NZD: 'NZ$',
}

function getCurrency(product) {
    return currencyDisplay[product.priceRange.maxVariantPrice.currencyCode];
}

function serializeData(object) {
    if (object.data && 
        object.data.products && 
        object.data.products.edges && 
        object.data.products.edges.length && 
        object.data.products.edges[0].node) {

        var product = object.data.products.edges[0].node;

        var serialized = {
            description: '',
            title: '',
            variants: {},
            options: [],
            variantSelected: '',
        };

        serialized.title = product.title;
        serialized.description = product.description.split('Includes:')[0].split('includes:')[0];
        if (product.variants && product.variants.edges) {
            serialized.options = product.options[0].values.map(x => x.split(':')[0]);
            serialized.variants = product.variants.edges.reduce(function (res, object, all) {
                const optionTitle = object.node.title.split(':')[0].replace(/ /g, '');
                res[optionTitle] = Object.assign({}, object);
                res[optionTitle].node.title = res[optionTitle].node.title.split(':')[0];
                res[optionTitle].price = `${getCurrency(product)}${object.node.price}`;
                res[optionTitle].compareAtPrice = res[optionTitle].node.compareAtPrice !== object.node.price ? res[optionTitle].node.compareAtPrice : null;
                return res;
            }, {});
            serialized.variantSelected = serialized.variants[product.options[0].values[0].replace(/ /g, '')];
        } else {
            serialized.price = `${getCurrency(product)}${product.priceRange.maxVariantPrice.amount}`
        }
        serialized.images = product.images &&
                            product.images.edges &&
                            product.images.edges.map(function (obj) {
                                return obj.node;
                            });
        return serialized;  
    }
    return null;
}

function initDetailModal(modalID, apiKey) {   
    document.addEventListener("DOMContentLoaded", function() {
        // Attach to every product list link
        var $modal = $(`#${modalID}`),
            $addToCart = $modal.find('#addToCart'),
            $viewFullDetails = $modal.find('#viewFullDetails'),
            $detailTitle = $modal.find('.product-detail__title'),
            $detailDescription = $modal.find('.product-detail__description'),
            $detailPrice = $modal.find('.product-detail__price'),
            $detailShowcase = $modal.find('.product-detail__showcase'),
            $detailImages = $modal.find('.product-detail__images'),
            $detailPreviews = $modal.find('.product-detail__previews'),
            $detailVariants = $modal.find('.product-detail__variants'),
            $detailDots = $modal.find('.product-detail__dots'),
            $qtyDown = $modal.find('.qty_btn.down'),
            $qtyValue = $modal.find('.qty_value'),
            $qtyUp = $modal.find('.qty_btn.up');
    
        var cleanModal = function cleanModal() {
            $addToCart.html('Add to Cart');
            $addToCart[0].disabled = false;
            $addToCart.off('click');
            $modal.off('mousedown touchstart');
            $modal.off('mouseup touchend');
            $modal.find('.sub').remove();
            
            $detailTitle.html('<span class="waiter">__________</span>');
            $detailDescription.html('<span class="waiter">________________</span>');
            $detailPrice.html('<span class="waiter">____</span>');
            $detailImages.html('<span class="waiter"></span>');
            $detailPreviews.html('');
            $detailDots.html('');
            $qtyValue.html('1');

            $viewFullDetails.off('click');
            $modal.trigger('SHOWCASE_IMAGE_CHANGE', 0);
        }
    
        function onAddToCart(serialized) {
            var variantId = atob(serialized.variantSelected.node.id).split('/');
            var qty = Number($qtyValue.html());
            variantId = variantId[variantId.length-1];
            // $AddToCart.disable
            Shopify.AjaxifyCart.addToCart.call($modal, {
                addToCartBtnSelector: '#addToCart',
                feedbackPosition: 'noFeedback',
                product: {
                    id: variantId,
                    quantity: qty,
                },
            });
        }

        $(`#modal_close_${modalID}, .ring-modal__backdrop`).click(function () {
            $modal.trigger('CLOSE_MODAL');
        });

        $modal.on('CLOSE_MODAL', function () {
            setTimeout(function () {
                cleanModal();
            }, 100);
        });
        
        $modal.on('QUANTITY_UP', function qtyUp() {
            var value = Number($qtyValue.html());
            $qtyValue.html(value+1);
        });
    
        $modal.on('QUANTITY_DOWN', function qtyDown() {
            var value = Number($qtyValue.html());
            if (value > 1) {
                $qtyValue.html(value-1);
            }
        });
    
        $qtyDown.click(function qtyDownClick() {
            $modal.trigger('QUANTITY_DOWN');
        });
    
        $qtyUp.click(function qtyUpClick() {
            $modal.trigger('QUANTITY_UP');
        });
    
        $modal.on('FILL_DATA', function fillData(e, serialized) {
            if (!serialized) return;
            $detailTitle.html('');
            $detailDescription.html('');
            $detailPrice.html('');
            $detailImages.html('');
            $detailPreviews.html('');
            $detailDots.html('');
    
            let title = serialized.title.split('for ')[0].split('(')[0];
            const subTitle = serialized.title.split('for ')[1] && serialized.title.split('for ')[1].replace(')', '');
            
            title = title.replace(/(pro|Pro)/g, ' <span class="orange">Pro</span>').replace(' Elite', '<span class="blue"> Elite</span>');
            
            $detailTitle.html(title);
            $detailTitle.after(subTitle ? `<div class="sub">${subTitle}</div>`: '');
            $detailDescription.html(serialized.description);
            $detailPrice.html(`${serialized.variantSelected.price} ${serialized.variantSelected.compareAtPrice ? `<span class="h-strikethrough">${serialized.variantSelected.compareAtPrice}</span>` : '' } `);
    
            $addToCart
                .click(onAddToCart.bind(
                    null, 
                    serialized,
                ));
    
            $viewFullDetails.click(function () {
                window.location.href = serialized.productUrl;
            });
    
            // Images
            serialized.images.reduce(function (res, imgObject, index) {
                var option = imgObject.altText && imgObject.altText.split(':')[0];
                if (!option) {
                    option = res;
                }
                $detailImages.append(`
                    <img
                        src="${imgObject.transformedSrcPreview}"
                        alt="${option}" 
                        data-option="${option}"
                        data-index="${index}" />`);
                $detailPreviews.append(`
                    <img 
                        class="product-detail__preview"
                        data-option="${option}"
                        data-index="${index}"
                        src="${imgObject.transformedSrcIcon}"
                        alt="${option}"/>`);
                return option;
            }, undefined);
    
    
            // Swipe functionality
            let xDown, xUp; 
            $modal.on('mousedown touchstart', function (e) {
                //e.preventDefault();
                xDown = e.pageX || e.originalEvent.touches[0].pageX;
            }).on('mouseup touchend',function (e) {
                xUp = e.pageX || e.originalEvent.changedTouches[0].pageX;
                if(xDown != xUp && Math.abs(xDown-xUp) > 50){
                    if(xDown > xUp){
                        swipe('left');
                    }else{
                        swipe('right');
                    }
                }
            });
    
            function swipe(dir) {
                if(window.innerWidth > 768) return;
                // Gets current index by looking in the class
                const currentIndex = $detailShowcase[0].classList[1].split('-')[2]*1;
                const lastIndex = $detailShowcase.find('.product-detail__preview').last()[0].dataset.index*1;
                const toIndex = ({
                    'right': () => {
                        if (currentIndex === 0) {
                            return lastIndex;
                        } else {
                            return currentIndex - 1;
                        }
                    },
                    'left': () => {
                        if (currentIndex === lastIndex) {
                            return 0;
                        } else {
                            return currentIndex + 1;
                        }
                    }
                })[dir]();
                $modal.trigger('OPTION_CHANGE', { 
                    serialized, 
                    option: $detailPreviews.find(`.product-detail__preview[data-index=${toIndex}]`)[0].dataset.option,
                });
                $modal.trigger('SHOWCASE_IMAGE_CHANGE',
                    toIndex);
            }
    
            // Icons in desktop
            $detailPreviews.find('.product-detail__preview').click(function handlePreview(e) {
                $modal.trigger('OPTION_CHANGE', { 
                    serialized, 
                    option: this.dataset.option,
                });
                $modal.trigger('SHOWCASE_IMAGE_CHANGE',
                    this.dataset.index);
            });
    
            // Variants dots
            if (serialized.variants) {
                // If only one variant we hide color options
                if (Object.keys(serialized.variants).length === 1) {
                    $detailVariants.addClass('hidden');
                } else {
                    $detailVariants.removeClass('hidden');
                    Object.keys(serialized.variants).map(function (variant) {
                        var variant = serialized.variants[variant];
                        var isActive = variant === serialized.variantSelected;
                        var title = variant.node.title.replace(/ /g, '').split(':')[0];
                        $detailDots.append(`
                            <div class="dot ${title.toLocaleLowerCase()} ${isActive ? 'active' : ''}" 
                                data-option="${title}"
                                title="${title}">
                            </div>
                        `);
                        $detailDots.find('.dot').click(function(e) {
                            $modal.trigger('OPTION_CHANGE', {
                                serialized,
                                option: this.dataset.option,
                            });
                        });
                    });
                }
            }
        });
    
        $modal.on('OPTION_CHANGE', function fillData(e, change) {
            var variantSelected = change.serialized.variants[change.option];
            if (variantSelected) {
                change.serialized.variantSelected = variantSelected;
                // Trigger Image change
                var imageIndex = change.serialized.images.map(x => x.altText && x.altText.split(':')[0]).indexOf(variantSelected.node.title);
                if (imageIndex >= 0) $modal.trigger('SHOWCASE_IMAGE_CHANGE', imageIndex);
                // Price
                $detailPrice.html(change.serialized.variantSelected.price);
                // Dots change
                $detailDots.find('.dot').each(function () {
                    var dot = this;
                    dot.classList.remove('active');
                    if (dot.dataset.option === change.option) {
                        dot.classList.add('active');
                    }
                });
            }
        });
    
        $modal.on('SHOWCASE_IMAGE_CHANGE', function fillData(e, index) {
            // Removes all classes except $detailShowcase main class.
            $detailShowcase.removeClass($detailShowcase[0].className.split(' ').filter(x => x !== 'product-detail__showcase')[0]);
            $detailShowcase.addClass(`active-index-${index}`);
        });
        
        document.querySelectorAll('.quick-view-button').forEach(x => x.onclick = function (e) {
            var productId = this.dataset.id;
            var productUrl = this.dataset.producturl;
            e.preventDefault();
    
            // Open Modal
            $modal.fadeIn();
            
            // TODO: CACHE BY ID
            $.ajax({
                url: `/api/graphql.json`,
                type: 'POST',
                beforeSend: setStorefrontAPIHeaders(apiKey),
                data: `
                {
                    products(first:1, query: "id:'${productId}'"){
                        edges {
                            node {
                                title
                                priceRange {
                                    maxVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                }
                                description
                                options {
                                    name
                                    values
                                }
                                images(first: 10) {
                                    edges  {
                                        node {
                                            originalSrc
                                            altText
                                            transformedSrcIcon: transformedSrc(maxWidth: 100, maxHeight: 100)
                                            transformedSrcPreview: transformedSrc(maxWidth: 500, maxHeight: 500)
                                        }
                                    }
                                }
                                variants(first: 250) {
                                    pageInfo {
                                    hasNextPage
                                    hasPreviousPage
                                    }
                                    edges {
                                    cursor
                                        node {
                                            id
                                            title
                                            price
                                            available: availableForSale
                                            sku
                                            compareAtPrice
                                            image {
                                                id
                                                src: originalSrc
                                                altText
                                            }
                                            selectedOptions {
                                                name
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`, 
                success: function onSuccess(data) {
                    var serializedData = serializeData(data);
                    serializedData.productUrl = productUrl;
                    $modal.trigger('FILL_DATA', serializedData);
                }
            })
            return false;
        });
    });
}    
